export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5593.f9a8c32e.jpg";